module.exports = __webpack_public_path__ + "static/media/boss-heading.fe7358d4.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/boss-heading.png
// module id = 130
// module chunks = 0